import { Inject, Injectable } from '@angular/core';
import { RegimeAttributesUpdateRequest } from '@assetaccountant/api/models/regime-attributes-update.request';
import { AssetRegime } from '@assetaccountant/assets/models/asset';
import { ToastrService } from 'ngx-toastr';

import { AssetGroupRegimeDto } from '@assetaccountant/api/models/asset-group-regime.dto';
import { AssetGroupDto } from '@assetaccountant/api/models/asset-group.dto';
import { AssetGroupV2Api } from '@assetaccountant/api/services/asset-group-v2.api';
import { CompareFn, SORT_COMPARE } from './compare.factory';

@Injectable({
  providedIn: 'root',
})
export class AssetGroupsService {
  constructor(
    private assetGroupApi: AssetGroupV2Api,
    private toastr: ToastrService,
    @Inject(SORT_COMPARE) private sortCompare: CompareFn,
  ) {}

  updateAssetGroupFromAsset(
    assetRegimes: Array<AssetRegime & RegimeAttributesUpdateRequest>,
    group: AssetGroupDto,
  ) {
    if (group) {
      const regimes: AssetGroupRegimeDto[] = [];
      assetRegimes.forEach(r => {
        const regime = {
          assetGroupId: group.assetGroupId,
          regimeId: r.regimeId,
          depreciationMethodId: r.depreciationMethodId,
          life: r.life,
          rate: r.rate,
          regimeName: r.regimeName,
          depreciationRules: r.depreciationRules,
        } as AssetGroupRegimeDto;

        regimes.push(regime);
      });

      const assetGroup = group;
      assetGroup.assetGroupRegimes = regimes;

      this.assetGroupApi
        .updateAssetGroup({ assetGroupId: assetGroup.assetGroupId, assetGroup })
        .subscribe(
          () => {
            this.toastr.success(`Asset Group '${assetGroup.name}' has been updated.`);
          },
          error => {
            this.toastr.error('Failed to update Asset Group.');
          },
        );
    } else {
      this.toastr.error('Failed to update Asset Group.');
    }
  }

  sortAssetGroups<T extends { parentGroup?: string; name: string }>(assetGroups: T[]) {
    return assetGroups.sort((a, b) => {
      // Sort groups with parents first
      if (a.parentGroup && !b.parentGroup) {
        return -1;
      }
      if (!a.parentGroup && b.parentGroup) {
        return 1;
      }

      // Sort by parent group name then group name
      return (
        this.sortCompare(a.parentGroup || '', b.parentGroup || '') ||
        this.sortCompare(a.name, b.name)
      );
    });
  }
}
